import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        // we init with resources
        resources: {
            en: {
                translations: {
                    /*FROM API*/
                    IncorrectLoginOrPassword: "The username or password you entered is not valid",
                    UserExists: "A user with that username already exists",
                    UserDoesNotExist: "The user does not exist",
                    UserCannotDeleteSelf: "The user cannot delete itself",
                    InvalidCode: "The confirmation code is not correct",
                    NoMailsToSend: "There are no mails registered to send the invoice",
                    IbanMissingForCompany: "There is no IBAN registered for this company and the following currency: {{param}}",
                    ActivityOutsideProjectRange: "The activity period do not match the project period",
                    PasswordMismatch: "The passwords do not match",
                    ResetCodeNotFound: "The reset code is not valid",
                    UserNotFound: "The user could not be found",
                    UserMailExists: "A user with the same email already exists",
                    WinbizCompanyNotFound: "Can't find Winbiz Company: {{param}}",
                    WinbizLoginError: "Winbiz login details are incorrect",
                    WinbizError: "An error has ocurred while connecting to Winbiz: {{param}}",
                    NoWinbizConfigFound: "No Winbiz configuration found. Please complete it",
                    NoInvoicesToSync: "There are no pending invoics to sync",
                    DataLoadedOutsideRange: "There are hours loaded for a month outside the activities range: {{param}}",
                    NoSalariesToSync: "There are no pending activities configured for salary",
                    NoSummaryForInvoice: "There is no historic data for this invoice",
                    WagesItemNumberOutsideRange: "The number of items in the salary is bigger than the range provided",
                    TemplateEventAlreadyConfigured: "A template is already configured for that event",
                    NoTimesheet: "There are no hours loaded for this period",
                    CurrencyInUseClient: "A client is using this currency: {{param}}",
                    CurrencyInUseSalary: "A user is using this currency in salary: {{param}}",
                    CurrencyInUseIBAN: "A company has an IBAN with this currency: {{param}}",
                    NoEmailServer: "There is no email server configured",
                    SMTPConnectionError: "The email server credentials are incorrect",
                    CurrencyCodeAlreadyExists: "Currency code already exists",
                    RateAlreadyExists: "An exchange rate for this period and currency already exists",
                    ConsultantIsNotEnableForSalary: "Consultant is not enable for salary",
                    ItemHasWrongDate: "Some expense items have an incorrect date",
                    ExpenseNotFound: "No information was found for this expense",
                    MissingPayrollSectionCode: "Missing payroll section code for: {{param}}",
                    NoExpenseToSync: "There are no expenses ready to sync",
                    InvalidRange: "Invalid date period",
                    DefinitionAlreadyExists: "Another definition overlaps this date period",
                    ActivityOutsideRange: "The selected period is outside the valid date range for the activity",
                    ArchivedVATError: "You cannot save expenses with an archived VAT rate",
                    ClientIsValidatorForProjects: "This user is set as a validator for the projects below.<br/><br/>Please assign a replacement before deleting this user or press Yes to delete the user and remove it as validator from these projects",
                    internalExpensesWithPackageSavedSuccessfully: 'Package expenses saved successfully',

                    includeDeleted:"Include deleted",
                    host: "Email Server Host",
                    port: "Email Server Port",
                    emailSettingsUpdated: "Email server configuration was updated",
                    emailSettings: "Email Server",


                    templateEvent: "Use automatically for this event",


                    timesheetSent: "Timesheet Sent for Validation",
                    timesheetReject: "Timesheet Rejected by Validator",
                    rejectReason: "Reason for rejection",

                    recentlyChanged: "Recently edited",
                    emailFromAdministrator: "Message from Administrator",
                    sender: "Sender",
                    recipient: "Recipient",

                    english: "English",
                    french: "French",

                    timesheet: "Timesheets",
                    documents: "Documents",
                    reports: "Reports",
                    user: "User",
                    username: "Username",
                    password: "Password",
                    signIn: "Sign In",
                    recoverPassword: "Change or recover password",
                    countryCode: "gb",
                    administration: "Administration",
                    users: "Users",
                    activities: "Activities",
                    projects: "Projects",
                    clients: "Clients",
                    companies: "Companies",
                    language: "Language",
                    logout: "Logout",
                    edit: "Edit",
                    copy: "Copy",
                    delete: "Delete",
                    name: "First name",
                    surname: "Last name",
                    email: "E-mail",
                    pendingValidation: "Pending approval",
                    rejected: "Rejected",
                    validatedByClient: "Pending CH Finance approval",
                    prebilled: "Pre-Billed",
                    billed: "Billed",
                    newUser: "New user",
                    newActivity: "New activity",
                    admin: "Administrator",
                    consultant: "Consultant",
                    client: "Client",
                    type: "Type",
                    userCode: "User code",
                    actions: "Actions",

                    acvitityTitle: "Activity title",
                    codeWinbiz: "WinBiz code",
                    invoiceText: "Billing text",
                    inputUnit: "Input unit",
                    billingUnit: "Billing unit",
                    privacy: "Confidential",
                    billableClient: "Billable client",

                    newProject: "New Project",
                    projectName: "Project name",
                    description: "Description",

                    newClient: "New client",
                    society: "Society",
                    validators: "Approvers",
                    consultants: "Consultants",
                    currency: "Currency",
                    newCurrency: "New Currency",
                    paymentTerms: "Payment terms",

                    companyName: "Company name",
                    billingAddress: "Billing address",
                    company: "Company",
                    newCompany: "New company",
                    societyName: "Society name",
                    winbizFile: "WinBiz file",
                    address: "Address",
                    postalCode: "Postal code",
                    bankInfo: "Bank information",

                    confirmDelete: "Are you sure you want to delete?",
                    yes: "Yes",
                    no: "No",

                    uploadDocument: "Upload document",
                    file: "File",
                    modified: "Modified",
                    author: "Author",

                    inputationHours: "Imputation hours",
                    summaryActivities: "Summary activities",
                    project: "Project",
                    activity: "Activity",
                    unit: "Unit",
                    total: "Total",
                    docsReceived: "Doc received",
                    invoice: "Invoice",
                    salary: "Salary",
                    rationaleNDF: "Rationale NDF",
                    hours: "Hours",
                    generateReport: "Generate report",
                    save: "Save",
                    saveMonth: "Save month",
                    title: "Title",
                    billingText: "Billing text",
                    winbizCode: "Winbiz code",
                    salaryText: "Salary Text",
                    salaryUnit: "Salary Unit",
                    workUnit: "Unit of entry",
                    tva: "VAT",
                    startDate: "Start period",
                    endDate: "End period",
                    dragDropDocuments: "Drag & drop files",
                    dragAndDropHere: "Drop files here",
                    assignActivityToConsultant: "Assign activity to consultant",
                    files: "Files",
                    date: "Date",
                    consultantInfo: "Consultant",
                    billing: "Billing",
                    templates: "Email templates",
                    template: "Template",
                    newTemplate: "New template",
                    createNew: "New",
                    relatedActivity: "Select activity related to the document",
                    sendWinbiz: "Send to WinBiz",
                    sendPreBilled: "Send to pre-billed",

                    validator: "Approver",
                    zoneArea: "Zone area",
                    numberCommand: "No Command",
                    billingEmail: "Billing email (Multiple)",
                    billingEmailCopy: "Billing email (Copy)",
                    billingEmailsBbc: "Billing email (BCC)",
                    clientValidator: "Validator (Client)",
                    assignProjectClient: "Client assigned",

                    billedActivities: "Billed activities",
                    approve: "Approve",
                    reject: "Reject",
                    fieldRequired: "This field is required",
                    invalidCredentials: "The user and password do not match",
                    errorOcurred: "An error ocurred",

                    status: "Status",
                    activitiesPending: "Activities pending for approval",
                    validated: "Approved",
                    sendToValidate: "Send month for approval",

                    pendingConsultant: "Pending Consultant",
                    pendingValidationClient: "Pending client approval",
                    none: "None",

                    code: "Code",
                    paymentCondition: "Payment terms",
                    addressNo: "Address number",
                    corporateName: "Corporate name",
                    NPA: "NPA (country code)",
                    country: "Country",
                    enterValue: "Please enter a value..",
                    enterMessage: "Please enter your message..",
                    wasUpdated: "{{entity}} was updated successfully",
                    wasDeleted: "{{entity}} was deleted successfully",
                    wasCreated: "{{entity}} was created successfully",
                    to: "to",
                    of: "of",
                    hour: "Hour",
                    day: "Day",
                    currencyAmount: "Amount",

                    confirmCopy: "Do you want to duplicate this item?",
                    copyItem: "Duplicate this item",
                    wasDuplicated: "{{entity}} was duplicated successfully",
                    noItemsFound: "No items found",
                    noFiles: "No files..",
                    filetypeNotValid: "Incorrect file type",
                    cancel: "Cancel",
                    activityCode: "Activity Code",
                    activityName: "Activity Name",
                    unitAmount: "Unit Amount",
                    noTVA: "VAT Number",
                    city: "City",
                    phone: "Phone",
                    website: "Website",
                    beneficiary: "Beneficiary",
                    bank: "Bank",
                    swift: "SWIFT - BIC",
                    iban: "IBAN",
                    clientName: "Client Name",
                    clientCode: "Client Code",
                    invoiceHeaderText: "Invoice Header Text",
                    billingFullName: "Full name for Billing",
                    billingContactMail: "Billing Email",
                    billingContact: "Billing Contact Information",
                    pleaseEnter2FACode: "Please enter the security code generated by your Authenticator app",
                    twoFactorCode: "Confirmation Code",
                    welcome: "Welcome",
                    authenticatorQRCode: "Scan the QR Code using",
                    salaryWinbizCode: "Salary Code",
                    variables: "Variables",
                    monthVariable: "Number of the month (01 for January)",
                    yearVariable: "for this year",
                    winbizActivityName: "Salary Item",
                    all: "All",
                    noActivitiesFound: "No activities found..",
                    confirmValidationMessage: "{{number}} activities will be sent to the client for approval. Do you wish to continue?",
                    confirmApproveMessage: "You will approve {{number}} activities. Do you wish to continue?",
                    confirmRejectMessage: "You will reject {{number}} activities. Do you wish to continue?",
                    confirmAdminValidation: "You will approve {{number}} activities. Do you wish to continue?",
                    validateConfirmation:"Validate",
                    hoursUpdated: "Timesheet saved successfully",
                    monthsSentPending: "Timesheet sent for approval successfully",
                    monthsRejected: "Timesheet rejected successfully",
                    monthsValidated: "Timesheet approved successfully",
                    monthsFinalized: "Timesheet finalized successfully",
                    noInvoicesFound: "No invoice found",
                    created: "Created",
                    sent: "Sent",
                    billingPeriod: "Billing period",
                    currencies: "Currencies",
                    shortName: "Short name",
                    symbol: "Symbol",
                    finalized: "Finalized",
                    loading: "Loading...",
                    search: "Search..",
                    searchBy: "Search by:",
                    clearFilters: "Clear filters",
                    currency2: "Currency",
                    vats: "VAT Rates (Sales)",
                    tax: "Rate",
                    text: "Text",
                    reason: "Reason",
                    validate: "Validate",
                    singleInvoice: "Invoice",
                    multipleInvoice: "Invoice All",
                    filter: "Filter by..",
                    logo: "Logo",
                    header: "Header",
                    filterQuery: "Current filter",
                    eq: "Equals",
                    contains: "Contains",
                    doesnotcontain: "Does Not Contain",
                    neq: "Is Not Equal To",
                    startswith: "Starts With",
                    endswith: "Ends With",
                    isnull: "Is Null",
                    isnotnull: "Is Not Null",
                    isempty: "Is Empty",
                    isnotempty: "Is Not Empty",
                    true: "Yes",
                    false: "No",
                    goBack: "Go Back",
                    vat: "Vat rate",
                    newVat: "New VAT rate",
                    noInvoiceSelected: "No Invoice Selected",
                    sendMessage: "Send Message",
                    sendMessageToAdministrator: "Send Message to Administrator",
                    sendUserMessage: "Send an e-mail to the consultant",
                    emailSent: "E-mail sent",
                    message: "Message",
                    send: "Send",
                    messageReceived: "sent you the following message:",
                    ok: "OK",
                    ignore: "Ignore",
                    messageSent: "Message Sent",
                    messageIgnored: "Message Ignored",
                    sending: "Sending..",
                    invoiceSent: "Invoice sent",
                    invoiceCancelled: "Invoice cancelled",
                    cancelInvoiceConfirmation: "Do you wish to cancel this invoice?",
                    invoiceMailConfirmation: "You will be sending an invoice to the following emails",
                    invoiceConfirmation: "Invoice Confirmation",
                    cancelCreditNote: "Cancel Credit Note",
                    cancelCreditNoteConfirmation: "Do you wish to cancel this credit note?",
                    creditNoteCancelled: "Credit note cancelled",
                    changeInvoiceDate: "Change document date",
                    changeInvoiceDateConfirmation: "Please enter the new date below",
                    invoiceDateChanged: "The document date has been changed",
                    sendReport: "Send Report",
                    report: "Report",
                    filename: "Filename",
                    for: "For",
                    download: "Download",
                    cancelInvoice: "Cancel Invoice",
                    createCreditNote: "Create Credit Note",
                    creditNote: "Credit Note",
                    cancelled: "Cancelled",
                    shortStartDate: "Start",
                    shortEndDate: "End",
                    shortConfidential: "Conf.",
                    shortBillable: "Bill. Client",
                    shortWorkUnit: "Work Unit",
                    shortBillingUnit: "Bill. Unit",
                    shortAmount: "Amount",
                    shortSalaryUnit: "Salary Unit",
                    pleaseAddEmail: "Please define at least one email in the project - Click here",
                    workflow: "Workflow",
                    sentDownloaded: "Sent/Downloaded",
                    winbizSynced: "Invoices Synchronization",
                    salarySynced: "Salary Synchronization",
                    noProject: "No Project",
                    information: "Month information",
                    projectReportConfig: "Project's Report Configuration",
                    editUserInformation: "Edit user information",
                    informationSaved: "User information saved",
                    clickToEdit: "Click to edit this information",
                    expense: "Expenses",
                    expenseUnit: "Expense",
                    monthStatusUpdated: "Month status updated",
                    finish: "Finish",
                    reopen: "Reopen",
                    currentStatus: "Current Status",
                    finished: "Finished",
                    open: "Open",
                    filterStatus: "Status",
                    hideFinished: "Hide Finished",
                    pleaseWait: "Please wait for the action to finish",
                    mobile: "Mobile Phone",
                    landline: "Landline Phone",
                    relationship: "Relation",
                    contactInformation: "Contact person",
                    profile: "User Profile",
                    myProfile: "My Profile",
                    profileChanged: "has changed the user profile:",
                    notificationMessageSent: "sent you a message:",
                    markAllAsRead: "Mark all as read",
                    noNotifications: "You have no notification left",
                    repeatPassword: "Repeat password",
                    enterResetCode: "Please enter below the code you received via email",
                    changePassword: "Change password",
                    passwordReset: "Password reset email sent",
                    passwordChanged: "Your password was changed successfully",
                    noUserInfo: "No user information available",
                    editInformation: "Edit month information",
                    thisUser: "This user",
                    creditNoteConfirmation: "Do you wish to create a credit note for this invoice?",
                    statusChange: "Status change",
                    statusChangeConfirmation: "Would you like to return to the pending approval status?",
                    nonBillableStatusChangeConfirmation: "Would you like to return non billable actvities to the pending approval status?",
                    creditNoteCreated: "Credit note was created successfully",
                    invoiceClientConfirmation: "You are invoicing the following projects: ",
                    winbizCloud: "Winbiz Cloud",
                    winbizSettings: "Settings",
                    loginAs: "Log in as another user",
                    loginAsConfirmation: "Do you wish to log in as this user?",

                    winbizKey: "Winbiz API Key",
                    winbizCompanyName: "Winbiz Company Name",
                    mustEqualWinbiz: "(must be the same as Winbiz)",
                    syncWinbizInvoices: "Sync invoices to Winbiz",
                    syncWinbizSalaries: "Sync salaries to Winbiz",
                    confirmWinbizInvoices: "Do you wish to send these invoices to Winbiz?",
                    confirmWinbizSalaries: "Do you wish to send salaries to Winbiz?",
                    invoiceSynced: "Invoices were synced to Winbiz",
                    winbizConfigSaved: "Winbiz configuration saved!",
                    winbizSynchronized: "Synchronized to Winbiz",
                    wagesSynced: "Salaries were synced to Winbiz",
                    winbizWageSynchronized: "Synced as salary to Winbiz",
                    cantSubmitEmptyMonths: "You cannot send months without hours",
                    cantApproveEmptyMonths: "You cannot approve months without hours",
                    generateFullTimesheet: "Create full report",
                    documentObsolete: "Due to multiple changes, this document is now obsolete",
                    noRecords: "No records available.",
                    dashboard: "Timesheet Dashboard",

                    period: "Period",
                    newRate: "New Exchange Rate",
                    rate: "Exchange rate",
                    rates: "Exchange rates",
                    xml: "XML",
                    xmlUpload: "Upload XML",
                    xmlUpdate: "Update via XML",
                    quantity: "Quantity",
                    countryEN: "Country EN",
                    countryFR: "Country FR",

                    telephoneIT: "Telephone and IT package",
                    km: "KM",
                    km2: "Distance to customer site (KM)",
                    breakfast: "Breakfast",
                    lunch: "Lunch",
                    dinner: "Dinner",
                    lodging: "Lodging",
                    defaultValues: "Default values",


                    packageExpenses: "Expenses with packages",
                    newPackageExpense: "New expense with package",
                    packageExpense: "Expense with package",
                    category: "Category",

                    active: "Active",
                    winbizGL: "Winbiz GL Account",
                    winbizSalary: "Winbiz Salary Category",

                    countryCurrencies: "Currencies per country",
                    countryCurrency: "Currency per country",
                    newCountryCurrency: "New currency per country",

                    nameEN: "Name (English)",
                    nameFR: "Name (French)",
                    newExpenseWithCosts: "New expense with actual costs",
                    expensesWithCosts: "Expenses with actual costs",
                    expenseWithCosts: "Expense with actual costs",
                    vatCollected: "VAT collected",


                    telephoneITDefault: "Telephone and IT package default value",
                    rAllowance: "Representative allowance",

                    expenseVat: "VAT Rate (Purchasing)",
                    expenseVats: "VAT Rates (Purchasing)",
                    newExpenseVat: "New VAT Rate (Purchasing)",
                    winbiz: "Winbiz",
                    expenseWithCosts2: "Internal expense report with actual costs",
                    expenseWithPackages: "Internal expense report with packages",
                    generate: 'Generate',

                    expensesInternal: "Internal expense report",
                    internalExpensesWithPackages: 'Expense report with packages',
                    internalExpensesWithActualCosts: 'Expense report with actual costs in',
                    pendingForApproval: 'Pending for approval',
                    telAndInfo: 'Tel & Info',
                    amountInCurrency: "Amount in {{param}}",
                    vatAmount: "VAT Amount",
                    localCurrencyAmount: "Local Currency Amount",
                    totalAmount: "Total amount",
                    lowExpense: "Expense lower than CHF 50 is not allowed with representative allowance",
                    theInternalPackageExpenseDoesnotExist: 'The internal package expense doesn\'t exist',
                    validateInternalExpense: 'Validate internal expenses',
                    rejectInternalExpense: 'Reject internal expenses',
                    approveInternalExpenseSuccessfully: 'Approve internal expenses successfully',
                    rejectInternalExpenseSuccessfully: 'Reject internal expenses successfully',

                    billedExpense: 'Billed expenses',
                    billedExpenseSavedSuccessfully: 'Expenses saved successfully',

                    pdfReport: "PDF Report",
                    pdfReportSummary: "PDF Report (Summary)",
                    pdfReportDetailed: "PDF Report (Detailed)",
                    syncWinbizExpenses: "Sync Expenses to Winbiz",
                    accounting: "Accounting",
                    purchasing: "Purchasing",
                    confirmWinbizExpenses: "Do you wish to sync expenses for this period to Winbiz?",
                    expensesSynced: "Expenses synchronized to Winbiz !",
                    archived: "Archived",
                    initial: "Initial",
                    masterData: "Master Data",
                    sendTo: "To",
                    sendBcc: "BCC (separed by ;): ",
                    sendCc: "CC",
                    sendToPendingValidationInternalExpenseSuccessfully: "Internal expenses successfully sent back to pending for approval",
                    sendToPendingValidation: "Send back to pending for approval",
                    PleaseDefinePackageExpenseForThisPeriodAndCompany: "Please define package expense for this period and company",
                    localCurrencyVATAmount: 'Local currency VAT Amount',
                    WinbizCodeDefinitionIsNotCorrect: 'Winbiz code definition is not correct.',
                    mergeDocuments: "Merge documents",
                    invoiceNumber: "Invoice Number",
                    internalExpensesStatus: "Internal expenses status"
                }
            },
            fr: {
                translations: {
                    /*FROM API*/
                    IncorrectLoginOrPassword: "Le nom d'utilisateur ou le mot de passe que vous avez entré n'est pas valide",
                    UserExists: "Un utilisateur avec ce nom d'utilisateur existe déjà",
                    UserDoesNotExist: "L'utilisateur n'existe pas",
                    UserCannotDeleteSelf: "L'utilisateur ne peut pas se supprimer",
                    InvalidCode: "Le code de confirmation n'est pas correct",
                    NoMailsToSend: "Aucun email enregistré pour l'envoi de la facture",
                    IbanMissingForCompany: "Il n'y a pas d'IBAN enregistré pour cette entreprise et la devise suivante : {{param}}",
                    ActivityOutsideProjectRange: "La période d'activité ne correspond pas à la période du projet",

                    ArchivedVATError: "Vous ne pouvez pas enregistrer des notes de frais avec un taux de TVA archivé",
                    ClientIsValidatorForProjects: "Cet utilisateur est défini comme validateur pour les projets ci-dessous.<br/><br/>Veuillez désigner un remplaçant avant de supprimer cet utilisateur ou appuyez sur Oui pour supprimer l'utilisateur et le retirer en tant que validateur de ces projets",

                    PasswordMismatch: "Les mots de passe ne correspondent pas",
                    ResetCodeNotFound: "Le code de réinitialisation n'est pas valide",
                    UserNotFound: "L'utilisateur n'a pas été trouvé",
                    UserMailExists: "Un utilisateur avec le même email existe déjà",
                    WinbizCompanyNotFound: "Impossible de trouver Winbiz Company: {{param}}",
                    WinbizLoginError: "Les données de connexion à Winbiz sont incorrectes",
                    WinbizError: "Une erreur s'est produite lors de la connexion à Winbiz : {{param}}",
                    NoWinbizConfigFound: "Aucune configuration Winbiz n'a été trouvée. Veuillez la compléter",
                    NoInvoicesToSync: "Il n'y a pas de factures en attente à synchroniser",
                    DataLoadedOutsideRange: "Il y a des heures chargées pour un mois en dehors de la gamme d'activités: {{param}}",
                    NoSalariesToSync: "Il n'y a pas d'activités en cours configurées pour les salaires",
                    NoSummaryForInvoice: "Il n'y a pas de données historiques pour cette facture",
                    WagesItemNumberOutsideRange: "Le nombre d'éléments du salaire est supérieur à la fourchette fournie",
                    TemplateEventAlreadyConfigured: "Un modèle est déjà configuré pour cet événement",
                    NoTimesheet: "Il n'y a pas d'heures chargèes pour cette pèriode",

                    CurrencyInUseClient: "Un client utilise cette devise : {{param}}",
                    CurrencyInUseSalary: "Un utilisateur utilise cette devise dans son salaire : {{param}}",
                    CurrencyInUseIBAN: "Une sociètè a un IBAN avec cette devise: {{param}}",

                    NoEmailServer: "Aucun serveur de e-mail n'est configurè",
                    SMTPConnectionError: "Les informations d'identification du serveur de e-mail sont incorrectes",
                    CurrencyCodeAlreadyExists: "Le code de la devise existe déjà",
                    RateAlreadyExists: "Un taux de change pour cette période et cette devise existe déjà",

                    ConsultantIsNotEnableForSalary: "Le consultant n'est pas éligible au salaire",
                    ItemHasWrongDate: "Certains postes de notes de frais ont une date incorrecte",
                    ExpenseNotFound: "Aucune information n'a été trouvée pour cette note de frais",
                    MissingPayrollSectionCode: "Code de section de paie manquant pour: {{param}}",
                    NoExpenseToSync: "Il n'y a pas de notes de frais prêtes à être synchronisées",
                    InvalidRange: "Période non valide",
                    DefinitionAlreadyExists: "Une autre définition chevauche cette période de temps",
                    ActivityOutsideRange: "La période sélectionnée est en dehors de la plage de dates valides pour l'activité",

                    internalExpensesWithPackageSavedSuccessfully: 'Note de frais interne enregistrée avec succés',

                    includeDeleted: "Inclure supprimé",

                    host: "Hôte du serveur  de e-mail",
                    port: "Port du serveur de e-mail",
                    emailSettingsUpdated: "La configuration du serveur de e-mail a ètè mise à jour",
                    emailSettings: "Serveur de e-mail",


                    templateEvent: "Utiliser automatiquement pour cet événement",
                    timesheetSent: "Heures envoyées pour validation",
                    timesheetReject: "Heures rejetées par le validateur",
                    rejectReason: "Raison du rejet",
                    recentlyChanged: "Récemment modifié",
                    emailFromAdministrator: "Message de l'administrateur",
                    sender: "Expéditeur",
                    recipient: "Destinataire",

                    english: "Anglais",
                    french: "Français",

                    timesheet: "Rapports d'activité",
                    documents: "Documents",
                    reports: "Rapports",
                    user: "Utilisateur",
                    username: "Utilisateur",
                    password: "Mot de passe",
                    signIn: "Connexion",
                    recoverPassword: "Changer ou récupérer le mot de passe",
                    countryCode: "FR",
                    administration: "Administration",
                    users: "Utilisateurs",
                    activities: "Activités",
                    projects: "Projets",
                    clients: "Clients",
                    companies: "Sociétés",
                    language: "Langue",
                    logout: "Déconnexion",
                    edit: "Modifier",
                    copy: "Copier",
                    delete: "Supprimer",
                    name: "Prénom",
                    surname: "Nom",
                    email: "Email",
                    pendingValidation: "En attente de validation",
                    rejected: "Rejeté",
                    validatedByClient: "En attente de validation CH Finance",
                    prebilled: "Pré-facturation",
                    billed: "Facturé",
                    newUser: "Nouvel utilisateur",
                    newActivity: "Nouvelle activité",
                    admin: "Administrateur",
                    consultant: "Consultant",
                    client: "Client",
                    type: "Type",
                    userCode: "Code utilisateur",
                    actions: "Actions",

                    acvitityTitle: "Titre de l'activité",
                    codeWinbiz: "Code WinBiz",
                    invoiceText: "Texte de facture",
                    inputUnit: "Unité de saisie",
                    billingUnit: "Unité de facturation",
                    privacy: "Confidentiel",
                    billableClient: "Facturable client",

                    newProject: "Nouveau projet",
                    projectName: "Nom du projet",
                    description: "Description",

                    newClient: "Nouveau client",
                    society: "Society",
                    validators: "Valideurs",
                    consultants: "Consultants",
                    currency: "Devise",
                    newCurrency: "Nouvelle devise",
                    paymentTerms: "Conditions de paiement",
                    companyName: "Raison sociale",
                    billingAddress: "Adresse de facturation",

                    company: "Société",
                    newCompany: "Nouvelle entreprise",
                    societyName: "Nom de la société",
                    winbizFile: "Dossier WinBiz",
                    address: "Adresse",
                    postalCode: "Code postal",
                    bankInfo: "Informations bancaires",


                    confirmDelete: "Êtes-vous sûr de vouloir supprimer?",
                    yes: "Oui",
                    no: "Non",

                    uploadDocument: "Télécharger un document",
                    file: "Fichier",
                    modified: "Modifié le",
                    author: "Par",

                    inputationHours: "Heures d'imputation",
                    summaryActivities: "Résumé des activités",
                    project: "Projet",
                    activity: "Activité",
                    unit: "Unité",
                    total: "Total",
                    docsReceived: "Doc recus",
                    invoice: "Facture",
                    salary: "Salaire",
                    rationaleNDF: "Justifs de NDF",
                    hours: "Heures",
                    generateReport: "Générer un rapport",
                    save: "Sauvegarder",
                    saveMonth: "Sauvegarder le mois",
                    title: "Titre",
                    billingText: "Texte de facture",
                    winbizCode: "Code Winbiz",
                    salaryText: "Texte ligne pour le salaire",
                    salaryUnit: "Unité de salaire",
                    workUnit: "Unité de saisie",
                    tva: "TVA",
                    startDate: "Période de début",
                    endDate: "Période de fin",
                    dragDropDocuments: "Glisser-déposer des fichiers",
                    dragAndDropHere: "Déposer les fichiers ici",
                    assignActivityToConsultant: "Affecter l'activité au consultant",
                    files: "Fichiers",
                    date: "Date",
                    consultantInfo: "Consultant",
                    billing: "Facturation",
                    templates: "Modèle d'email",
                    template: "Modèle",
                    newTemplate: "Nouveau modèle d'email",
                    createNew: "Nouveau",
                    relatedActivity: "Sélectionnez l'activité liée au document",
                    sendWinbiz: "Envoyer à WinBiz",
                    sendPreBilled: "Envoyer à la pré-facturation",

                    validator: "Valideur",
                    zoneArea: "Zone area",
                    numberCommand: "No de commande",
                    billingEmail: "Email de facturation (multiple)",
                    billingEmailCopy: "Email de facturation (copie)",
                    billingEmailsBbc: "Email de facturation (BCC)",
                    clientValidator: "Valideur (client)",
                    assignProjectClient: "Client affecté",
                    billedActivities: "Activités facturées",
                    approve: "Approuver",
                    reject: "Rejeter",
                    fieldRequired: "Ce champ est obligatoire",
                    invalidCredentials: "L'utilisateur et le mot de passe ne correspondent pas",
                    errorOcurred: "Une erreur s'est produite",

                    status: "Statut",
                    activitiesPending: "Activités en attente de validation",
                    validated: "Validé",
                    sendToValidate: "Envoyer pour validation",

                    pendingConsultant: "En cours Consultant",
                    pendingValidationClient: "En attente de validation Client",
                    none: "Aucun",
                    code: "Code",

                    paymentCondition: "Conditions de paiement",
                    addressNo: "Adresse No",
                    corporateName: "Raison sociale",
                    NPA: "NPA (Code du pays)",
                    country: "Pays",
                    enterValue: "Veuillez entrer une valeur..",
                    enterMessage: "Veuillez saisir votre message..",
                    wasUpdated: "{{entity}} mis à jour avec succès",
                    wasDeleted: "{{entity}} supprimé avec succès",
                    wasCreated: "{{entity}} créé avec succès",
                    to: "à",
                    of: "sur",
                    hour: "Heure",
                    day: "Jour",
                    currencyAmount: "Montant",

                    confirmCopy: "Voulez-vous dupliquer cet élément ?",
                    copyItem: "Dupliquer cet élément",
                    wasDuplicated: "{{entity}} dupliqué avec succès",
                    noItemsFound: "Aucun élément trouvé",
                    noFiles: "Aucun fichier ..",
                    filetypeNotValid: "Type de fichier incorrect",
                    cancel: "Annuler",
                    activityCode: "Code activité",
                    activityName: "Nom activité",
                    unitAmount: "Montant unitaire",
                    noTVA: "No de TVA",
                    city: "Ville",
                    phone: "Téléphone",
                    website: "Site web",
                    beneficiary: "Bénéficiaire",
                    bank: "Banque",
                    swift: "SWIFT - BIC",
                    iban: "IBAN",
                    clientName: "Nom du client",
                    clientCode: "Code du client",
                    invoiceHeaderText: "Texte en-tête de facture",
                    billingFullName: "Nom du contact de facturation (nom et prénom)",
                    billingContactMail: "Email de facturation",
                    billingContact: "Contact de facturation",
                    pleaseEnter2FACode: "Veuillez saisir le code sécurité généré par votre app Authenticator",
                    twoFactorCode: "Code de confirmation",
                    welcome: "Bienvenue",
                    authenticatorQRCode: "Scannez le QR code avec",
                    salaryWinbizCode: "Code salarié",
                    variables: "Variables",
                    monthVariable: "Numéro du mois (01 pour janvier)",
                    yearVariable: "pour cette année",
                    winbizActivityName: "Rubrique de salaire",
                    all: "Tous",
                    noActivitiesFound: "Aucune activité trouvée..",
                    confirmValidationMessage: "{{number}} activités seront envoyées au client pour validation. Souhaitez-vous continuer ?",
                    confirmApproveMessage: "Vous validerez {{number}} activités. Voulez-vous continuer ?",
                    confirmRejectMessage: "Vous rejetterez {{number}} activités. Voulez-vous continuer ?",
                    confirmAdminValidation: "Vous validerez {{number}} activités. Voulez-vous continuer ?",
                    validateConfirmation: "Valider",
                    hoursUpdated: "Rapport d'activité sauvegardé avec succès",
                    monthsSentPending: "Rapport d'activité envoyé pour validation avec succès",
                    monthsRejected: "Rapport d'activité rejeté avec succès",
                    monthsValidated: "Rapport d'activité validé avec succès",
                    monthsFinalized: "Rapport d'activité finalisé avec succès",
                    noInvoicesFound: "Aucune facture trouvée..",
                    created: "Créé",
                    sent: "Envoyé",
                    billingPeriod: "Période de facturation",
                    currencies: "Devises",
                    shortName: "Abréviation",
                    symbol: "Symbole",
                    finalized: "Finalisé",
                    loading: "Chargement...",
                    search: "Recherche..",
                    searchBy: "Recherche par:",
                    clearFilters: "Effacer les filtres",
                    currency2: "Monnaie",
                    vats: "Taux de TVA (Ventes)",
                    tax: "Taux",
                    text: "Texte",
                    reason: "Raison",
                    validate: "Valider",
                    singleInvoice: "Facturer",
                    multipleInvoice: "Facturer Tout",
                    filter: "Filtrer par..",
                    logo: "Logo",
                    header: "Header",
                    filterQuery: "Filtre actuel",
                    eq: "Est égal à",
                    contains: "Contient",
                    doesnotcontain: "Ne contient pas",
                    neq: "n'est pas égal à",
                    startswith: "Commence avec",
                    endswith: "Se termine par",
                    isnull: "est nul",
                    isnotnull: "Est non nulle",
                    isempty: "Est vide",
                    isnotempty: "N'est pas vide",
                    true: "Oui",
                    false: "Non",
                    goBack: "Retour",
                    vat: "Taux de TVA",
                    newVat: "Nouveau Taux de TVA",
                    noInvoiceSelected: "Aucune facture sélectionnée",
                    sendMessage: "Envoyer un message",
                    sendMessageToAdministrator: "Envoyer un message à l'administrateur",
                    sendUserMessage: "Envoyer un e-mail au consultant",
                    emailSent: "E-mail envoyé",
                    message: "Message",
                    send: "Envoyer",
                    messageReceived: "vous a envoyé le message suivant:",
                    ok: "OK",
                    ignore: "Ignorer",
                    messageSent: "Message envoyé",
                    messageIgnored: "Message ignoré",
                    sending: "Envoyer..",
                    invoiceSent: "Facture envoyé",
                    invoiceCancelled: "Facture annulée",
                    cancelInvoiceConfirmation: "Voulez-vous annuler cette facture ?",
                    invoiceMailConfirmation: "Vous enverrez une facture aux adresses électroniques suivantes",
                    invoiceConfirmation: "Confirmation de la facture",
                    cancelCreditNote: "Annuler la note de crédit",
                    cancelCreditNoteConfirmation: "Voulez-vous annuler cette note de crédit ?",
                    creditNoteCancelled: "Note de crédit annulée",

                    changeInvoiceDate: "Modifier la date du document",
                    changeInvoiceDateConfirmation: "Veuillez saisir la nouvelle date",
                    invoiceDateChanged: "La date du document a été modifiée",

                    sendReport: "Envoyer le rapport",
                    report: "Rapport",
                    filename: "Nom du fichier",
                    for: "Pour",
                    download: "Télécharger",
                    cancelInvoice: "Annuler la facture",
                    createCreditNote: "Créer une note de crédit",
                    creditNote: "Note de crédit",
                    cancelled: "Annulée",
                    shortStartDate: "Début",
                    shortEndDate: "Fin",
                    shortConfidential: "Conf.",
                    shortBillable: "Fact. Client",
                    shortWorkUnit: "U. saisie",
                    shortBillingUnit: "U. fact.",
                    shortAmount: "Montant",
                    shortSalaryUnit: "U. salaire",
                    pleaseAddEmail: "Veuillez définir au moins un email dans le projet - cliquer ici",
                    workflow: "Workflow",
                    sentDownloaded: "Envoyé/Téléchargé",
                    winbizSynced: "Synchronisation factures",
                    salarySynced: "Synchronisation salaire",
                    noProject: "Sans projet",
                    information: "Information",
                    projectReportConfig: "Configuration du rapport de projet",
                    editUserInformation: "Modifier les informations sur l'utilisateur",
                    informationSaved: "Informations sur l'utilisateur sauvegardées",
                    clickToEdit: "Cliquez pour modifier cette information",
                    expense: "Note de frais",
                    expenseUnit: "Frais de mission",
                    monthStatusUpdated: "Mise à jour de l'état du mois",
                    finish: "Terminer",
                    reopen: "Réouvrir",
                    currentStatus: "État actuel",
                    finished: "Terminé",
                    open: "En cours",
                    filterStatus: "État",
                    hideFinished: "Cacher terminé",
                    pleaseWait: "Veuillez attendre que l'action se termine",
                    mobile: "Téléphone mobile",
                    landline: "Téléphone fixe",
                    relationship: "Relation",
                    contactInformation: "Personne de contact",
                    profile: "Profil utilisateur",
                    myProfile: "Mon Profil",
                    profileChanged: "a modifié le profil de l'utilisateur:",
                    notificationMessageSent: "vous a envoyé un message:",
                    markAllAsRead: "Marquer tous comme lus",
                    noNotifications: "Vous n'avez plus de notification",
                    repeatPassword: "Répéter le mot de passe",
                    enterResetCode: "Veuillez saisir ci-dessous le code que vous avez reçu par e-mail",
                    changePassword: "Modifier le mot de passe",
                    passwordReset: "Le courriel de réinitialisation du mot de passe a été envoyé",
                    passwordChanged: "Votre mot de passe a été modifié avec succés",
                    noUserInfo: "Aucune information sur l'utilisateur n'est disponible",
                    editInformation: "Modifier les informations sur le mois",
                    thisUser: "Ce consultant",
                    creditNoteConfirmation: "Souhaitez-vous créer une note de crédit pour cette facture ?",
                    statusChange: "Changement d'état",
                    statusChangeConfirmation: "Souhaitez-vous revenir à l'état en attente de validation ?",
                    nonBillableStatusChangeConfirmation: "Souhaitez-vous que les activités non facturables reviennent à l'état en attente de validation ?",
                    creditNoteCreated: "La note de crédit a été créée",
                    invoiceClientConfirmation: "Vous facturez les projets suivants :",

                    winbizCloud: "Winbiz Cloud",
                    winbizSettings: "Paramètres",

                    loginAs: "Se connecter en tant qu'autre utilisateur",
                    loginAsConfirmation: "Souhaitez-vous vous connecter en tant que cet utilisateur ?",
                    winbizKey: "Winbiz API Key",
                    winbizCompanyName: "Winbiz Company Name",
                    mustEqualWinbiz: "(doit correspondre à winbiz)",
                    syncWinbizInvoices: "Synchroniser les factures avec Winbiz",
                    syncWinbizSalaries: "Synchroniser les salaires avec Winbiz",
                    confirmWinbizInvoices: "Souhaitez-vous envoyer ces factures à Winbiz ?",
                    confirmWinbizSalaries: "Souhaitez-vous envoyer les salaires à Winbiz ?",
                    invoiceSynced: "Les factures ont ètè synchronisèes avec Winbiz",
                    winbizConfigSaved: "Configuration Winbiz sauvegardèe",
                    winbizSynchronized: "Synchronisè avec Winbiz",
                    winbizWageSynchronized: "Synchronisation des salaires avec Winbiz",
                    wagesSynced: "Les salaires ont ètè synchronisèes avec Winbiz",
                    cantSubmitEmptyMonths: "Vous ne pouvez pas envoyer des mois sans heures",
                    cantApproveEmptyMonths: "Vous ne pouvez pas approuver des mois sans heures",
                    generateFullTimesheet: "Gènèrer un rapport complet",
                    documentObsolete: "En raison de changements, ce document est désormais obsolète",
                    noRecords: "Aucun enregistrement disponible.",
                    dashboard: "Tableu bord des feuilles de temps",

                    period: "Période",
                    newRate: "Nouveau taux de change",
                    rate: "Taux de change",
                    rates: "Taux de change",
                    xml: "XML",
                    xmlUpload: "Télécharger XML",
                    xmlUpdate: "Mise à jour via XML",
                    quantity: "Quantité",
                    countryEN: "Pays EN",
                    countryFR: "Pays FR",

                    telephoneIT: "Forfait téléphonie et informatique",
                    km: "KM",
                    km2: "Distance au site du client (KM)",
                    breakfast: "Petit déjeuner",
                    lunch: "Repas midi",
                    dinner: "Repas soir",
                    lodging: "Hébergement",
                    defaultValues: "Valeurs par défaut",

                    packageExpenses: "Notes de frais avec forfaits",
                    newPackageExpense: "Nouvelle note de frais avec forfait",
                    packageExpense: "Note de frais avec forfait",
                    category: "Catégorie",

                    active: "Actif",
                    winbizGL: "Compte Winbiz GL",
                    winbizSalary: "Catégorie salariale Winbiz",

                    countryCurrencies: "Devises par pays",
                    countryCurrency: "Devise par pays",
                    newCountryCurrency: "Nouvelle devise par pays",

                    nameEN: "Nom (anglais)",
                    nameFR: "Nom (français)",
                    newExpenseWithCosts: "Nouvelle note de frais avec frais réels",
                    expensesWithCosts: "Notes de frais avec frais réels",
                    expenseWithCosts: "Note de frais avec frais réels",
                    vatCollected: "TVA collectée",

                    telephoneITDefault: "Forfait téléphonie et informatique - Valeur par défaut",
                    rAllowance: "Frais de représentation",

                    expenseVat: "Taux de TVA (Achats)",
                    expenseVats: "Taux de TVA (Achats)",
                    newExpenseVat: "Nouveau Taux de TVA (Achats)",
                    winbiz: "Winbiz",
                    expenseWithCosts2: "Note de frais interne avec frais réels",
                    expenseWithPackages: "Note de frais interne avec forfaits",
                    generate: 'Générer',

                    expensesInternal: "Note de frais interne",
                    internalExpensesWithPackages: 'Note de frais avec forfaits',
                    internalExpensesWithActualCosts: 'Note de frais avec frais réels en',
                    totalAmount: "Montant total",
                    pendingForApproval: 'En attente d\'approbation',
                    telAndInfo: 'Tél & Info',
                    amountInCurrency: "Montant en {{param}}",
                    vatAmount: "Montant de TVA",
                    localCurrencyAmount: "Montant Devise locale",
                    lowExpense: "Une note de frais inférieure à CHF 50 n'est pas autorisée avec les frais de représentation",
                    theInternalPackageExpenseDoesnotExist: 'La note de frais forfait interne n\'existe pas',
                    validateInternalExpense: 'Valider les notes de frais internes',
                    rejectInternalExpense: 'Rejeter les notes de frais internes',
                    approveInternalExpenseSuccessfully: 'Notes de frais internes approuvées avec succès',
                    rejectInternalExpenseSuccessfully: 'Notes de frais internes rejetées avec succès',

                    billedExpense: 'Frais de mission refacturés',
                    billedExpenseSavedSuccessfully: 'Frais de mission enregistrés avec succès',
                    pdfReport: "Rapport PDF",
                    pdfReportSummary: "Rapport PDF (Résumé)",
                    pdfReportDetailed: "Rapport PDF (Détail)",
                    syncWinbizExpenses: "Synchroniser les notes de frais avec Winbiz",
                    accounting: "Comptabilité",
                    purchasing: "Achats",
                    confirmWinbizExpenses: "Souhaitez-vous synchroniser les notes de frais de cette période avec Winbiz ?",
                    expensesSynced: "Notes de frais synchronisées avec Winbiz !",
                    archived: "Archivée",
                    initial: "Initial",
                    masterData: "Données de base",
                    sendTo: "Envoyer à",
                    sendBcc: "Envoyer BCC (séparé par ;):",
                    sendCc: "Envoyer CC",
                    sendToPendingValidationInternalExpenseSuccessfully: "Notes de frais internes renvoyées avec succès en attente de validation",
                    sendToPendingValidation: "Renvoyer en attente de validation",
                    PleaseDefinePackageExpenseForThisPeriodAndCompany: "Veuillez définir les dépenses du forfait pour cette période et cette entreprise",
                    localCurrencyVATAmount: 'Montant TVA Devise locale',
                    WinbizCodeDefinitionIsNotCorrect: 'La définition du Code Winbiz n’est pas correcte.',
                    mergeDocuments: "Fusionner les documents",
                    invoiceNumber: "Num Facture",
                    internalExpensesStatus: "Statut note de frais"
                }
            }
        },
        fallbackLng: "fr",
        debug: true,

        ns: ["translations"],
        defaultNS: "translations",

        keySeparator: false,

        interpolation: {
            escapeValue: false
        }
    });

export default i18n;